import styled from 'styled-components'
import { Table, Button } from 'antd'
import { hexToRGBA } from '$utils'

export const StyledTable = styled(Table)`
  table {
    border-collapse: separate;
    border-spacing: 0 5px;
    background-color: ${(props) => props.theme.colorBgLightOne};
  }

  tbody tr {
    background-color: white;
    //cursor: pointer;
  }

  tbody tr:has(.pinned) td {
    background: #fbffe0 !important;
  }

  .ant-table tbody tr:has(.pinned) td {
    overflow: visible;
  }
  .ant-table tbody tr:has(.pinned) td:after {
    display: block;
    position: absolute;
    content: '';
    left: 0;
    width: 100%;
    bottom: -5px;
    border-top: 1px dashed #ccc;
    border-bottom: 1px dashed #ccc;
    height: 5px;
    opacity: 1;
    transition: opacity 1s ease-in-out;
  }
  .ant-table[data-page|='1'] tbody tr:has(.pinned) td:after {
    opacity: 0;
  }

  th::before {
    display: none;
  }

  .feas-col {
    width: 80px;
  }
  tr.ant-table-expanded-row > td,
  tr.ant-table-expanded-row:hover > td {
    background: #f8f8f8;
  }
  .ant-table-thead .ant-table-row-expand-icon-cell {
    background: ${(props) => props.theme.colorPrimaryBgHover};
  }
  .ant-table-wrapper {
    margin: 0 15px;
  }
  .ant-table-row-selected {
    background: ${(props) => props.theme.colorPrimaryBg};
  }
  .ant-table-pagination.ant-pagination {
    margin: 16px;
  }
  .ant-table-footer {
    width: 100%;
  }

  .ant-table-tbody > tr > td.ant-table-cell.vector8 {
    padding: 5px;
  }
`

const PartNo = (props) => `
  padding: 5px 15px !important;
  font-size: 12px;
  background: ${props.theme.colorBgLightSeven};
  border-color: ${props.theme.colorBgLightSix} !important;
  margin: -7px 0;
  :hover {
    border-color: ${props.theme.colorBgLightSix};
    background: #e7e7e7;
  }
`

export const PartNoButton = styled(Button)`
  ${(props) => PartNo(props)}
  height: 32px !important;
  :focus {
    background: ${(props) => hexToRGBA(props.theme.colorPrimary, 0.05)};
  }
`

export const PartNoDiv = styled.div`
  ${(props) => PartNo(props)}
  display: inline-block;
  border-radius: 6px;
`
